module.exports = __webpack_public_path__ + "static/img/menu4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/menu4.png
// module id = 558
// module chunks = 0